module.exports = __webpack_public_path__ + "static/media/portfolio7.67d06c14.png";